import React, { useState } from 'react'

import { Button, Tooltip } from '@mui/material'
import CSVReaderModule from 'react-csv-reader'
import { useFormContext } from 'react-hook-form'

import { post } from 'utils/http'

// react-csv-reader is a UMD/CJS bundle; Vite's prod build leaves the default wrapped as { default }, so unwrap defensively.
const CSVReader = (CSVReaderModule as { default?: typeof CSVReaderModule }).default ?? CSVReaderModule

const parseOptions = {
  header: true,
  skipEmptyLines: true,
  transformHeader: (header: string) => header.toLowerCase(),
}

const findMatchings = async (data: any) => {
  const search = data.map(({ name }: any) => name)

  return post('/management/companies/name_to_domain/aliases', search)
}

const NameToDomainCsvUpload = () => {
  const { setValue } = useFormContext()
  const [loading, setLoading] = useState(false)

  // Reveal per-row validation errors right after upload (else Save is disabled with no visible reason).
  // RHF ignores shouldValidate/shouldTouch when setValue targets a field-array name, so fill the array then touch+validate each leaf explicitly.
  const fillFormWithData = (rows: any[]) => {
    setValue('mappings', rows, { shouldDirty: true })
    rows.forEach((row, index) => {
      setValue(`mappings.${index}.name`, row.name, { shouldTouch: true, shouldValidate: true })
      setValue(`mappings.${index}.domain`, row.domain, { shouldTouch: true, shouldValidate: true })
    })
  }

  const handleFormData = async (data: any) => {
    try {
      const matchingResults = await findMatchings(data)
      const rows = data.map(({ name, domain }: any) => {
        const result = matchingResults.find(({ search }: any) => search === name)
        const matching = result.matchings.length === 1 ? result.matchings[0] : undefined
        const nameObject = {
          name: matching?.name,
          alias: matching?.alias || name,
          label: matching?.alias,
          verified: !!matching,
        }

        return { domain: domain.trim(), name: nameObject }
      })

      fillFormWithData(rows)
    } finally {
      setLoading(false)
    }
  }

  const handleFileLoaded = (data: any) => {
    setLoading(true)
    void handleFormData(data)
  }

  const tooltipText =
    'CSV file needs to contain two mandatory columns: name and domain. File should not be longer than the 500 lines. All currently added rows will be removed.'

  // Aliased so the polymorphic `component="span"` prop type-checks on Button.
  const UploadButton = Button

  const label = (
    <Tooltip title={tooltipText}>
      <UploadButton color="primary" component="span" loading={loading} variant="outlined">
        Upload CSV file
      </UploadButton>
    </Tooltip>
  )

  return (
    <CSVReader
      inputStyle={{ display: 'none' }}
      label={label}
      onFileLoaded={handleFileLoaded}
      parserOptions={parseOptions}
    />
  )
}

export default NameToDomainCsvUpload
